import Api from "./Api";

export default {
  getUrlPaymentPage(data) {
    return Api().post("payment/getUrlPaymentPage", data);
  },
};
